/**
 * @name numberFormatter
 * @param {num} value numeric signal value
 * @returns formatted string representation of numeric signal param
 */
export const numberFormatter = (value: number) => {
    if (value < 1000) {
        return `${value}`;
    }

    //returns: 2.8k
    return `${(value / 1000).toFixed(1)}k`.replace('.0', '');
};
